var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4703_57792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.999996 0.5C0.999996 0.223875 1.22375 0 1.5 0H14.5C14.775 0 15 0.223875 15 0.5C15 0.77625 14.775 1 14.5 1H1.5C1.22375 1 0.999996 0.77625 0.999996 0.5ZM0.499997 2.5C0.499997 2.22375 0.723746 2 0.999996 2H15C15.275 2 15.5 2.22375 15.5 2.5C15.5 2.77625 15.275 3 15 3H0.999996C0.723746 3 0.499997 2.77625 0.499997 2.5ZM7.24999 10.125C7.24999 9.75313 7.58437 9.5 7.99999 9.5C8.41562 9.5 8.74999 9.75313 8.74999 10.125C8.74999 10.4688 8.41562 10.75 7.99999 10.75C7.58437 10.75 7.24999 10.4688 7.24999 10.125ZM3 10C3 7.79063 5.23749 6 7.99999 6C10.7625 6 13 7.79063 13 10C13 12.2094 10.7625 14 7.99999 14C5.23749 14 3 12.2094 3 10ZM7.99999 13C10.4281 13 12 11.4594 12 10C12 8.54062 10.4281 7 7.99999 7C5.57187 7 4 8.54062 4 10C4 11.4594 5.57187 13 7.99999 13ZM14.1312 4C15.1594 4 15.9406 4.88438 15.8469 5.90938L15.1 14.4094C15.0187 15.3094 14.2625 16 13.3594 16H2.64156C1.73656 16 0.980621 15.3094 0.898746 14.4094L0.125965 5.90938C0.0328092 4.88438 0.839684 4 1.86875 4H14.1312ZM1.89468 14.3188C1.92968 14.7031 2.25375 15 2.64156 15H13.3594C13.7469 15 14.0687 14.7031 14.1062 14.3188L14.8781 5.81875C14.9187 5.37812 14.5719 5 14.1312 5H1.86875C1.42781 5 1.08187 5.37812 1.12187 5.81875L1.89468 14.3188Z",
    fill: "#FFC246"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4703_57792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.ccbb876c1a188280cd7040bd8937544d.svg";
export { ForwardRef as ReactComponent };